module.exports = __webpack_public_path__ + "img/footer-logo-believe-finance.95c3a25d.svg";